import 'react';
import 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { a as Icon } from '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import Heading from '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import Pane from '../Pane/index.js';

var DialogContent = styled(Box).withConfig({
  displayName: "styled__DialogContent",
  componentId: "sc-1loaala-0"
})(["padding:", "rem;max-height:90vh;overflow-y:", ";width:100%;&{", ";}"], space(5), function (props) {
  return props.hasScroll ? 'scroll' : 'visible';
}, theme('fannypack.Dialog.Content.base'));
var DialogHeader = styled(Box).withConfig({
  displayName: "styled__DialogHeader",
  componentId: "sc-1loaala-1"
})(["align-items:center;background-color:", ";display:flex;justify-content:space-between;padding:", "rem;width:100%;&{", ";}"], palette('white700'), space(5), theme('fannypack.Dialog.Header.base'));
var DialogFooter = styled(Box).withConfig({
  displayName: "styled__DialogFooter",
  componentId: "sc-1loaala-2"
})(["display:flex;align-items:center;background-color:", ";padding:", "rem ", "rem;width:100%;&{", ";}"], palette('white700'), space(4), space(4), theme('fannypack.Dialog.Footer.base'));
var DialogTitle = styled(Heading).withConfig({
  displayName: "styled__DialogTitle",
  componentId: "sc-1loaala-3"
})(["&&{margin-bottom:0px;}&{", ";}"], theme('fannypack.Dialog.Title.base'));
var DialogClose = styled(Button).withConfig({
  displayName: "styled__DialogClose",
  componentId: "sc-1loaala-4"
})(["min-height:1.5em;width:1.5em;padding:0px;&:hover{background-color:", ";&{", ";}}&{", ";}"], palette('white700'), theme('fannypack.Dialog.Close.hover'), theme('fannypack.Dialog.Close.base'));
var DialogIcon = styled(Icon).withConfig({
  displayName: "styled__DialogIcon",
  componentId: "sc-1loaala-5"
})(["margin-right:", "rem;&{", ";}"], space(2), theme('fannypack.Dialog.Icon.base'));
var Dialog = styled(Pane).withConfig({
  displayName: "styled__Dialog",
  componentId: "sc-1loaala-6"
})(["border-radius:5px;&:focus{outline:unset;}&{", ";}"], theme('fannypack.Dialog.base'));

export default Dialog;
export { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogIcon, DialogTitle };
